{
    "NextrunningatLabel": "La prochaine course à pied :",
    "LastrunatLabel": "Dernier passage à :",
    "StatuserrorLabel": "Statut \/ Erreur :",
    "ScheduleStatus_SectionHeader": "Statut de l'ordonnancement",
    "NAME": "ScheduleStatus"
}